
import { InputGroup } from '@naker/design/Layers/actionPanel';
import { Button } from '@naker/design/Inputs/button';

import { Particle, particleInterface } from '../viewer/particle';
import { point3D } from '../viewer/interface';
import { BackUndo } from './service/undo';

import { el, mount, setAttr } from 'redom';

/*
  +------------------------------------------------------------------------+
  | MOVEMENT MANAGER                                                    |
  +------------------------------------------------------------------------+
*/

export class movementSettingsClass extends InputGroup {

    particle: Particle
    undo: BackUndo

    constructor(undo: BackUndo, parent:HTMLElement, particle:Particle) {
        super('movement', parent, undo);
        setAttr(this.el, { class: 'movement-layer'});
        this.particle = particle;
        this.undo = undo;

        this.addInputs();
        this.direction1 = particle.direction1;
        this.direction2 = particle.direction2;
        this.checkActiveButtons();

        undo.on("change", (change) => {
            if (change.particle) this.resetInput(change.particle);
        });
    }

    centerButton:Button;

    directionButtons1:any = {};
    directionButtons2:any = {};
    direction1:point3D = {x:0, y:0, z:0};
    direction2:point3D = {x:0, y:0, z:0};
    directionChange = 100;

    movements = [
        { direction:'1', axe:'x' },
        { direction:'1', axe:'y' },
        { direction:'1', axe:'z' },
        { direction:'2', axe:'x' },
        { direction:'2', axe:'y' },
        { direction:'2', axe:'z' },
    ]
    addInputs() {
        let buttonList = el('div.movement-list', this.movements.map(move =>
            this['directionButtons'+move.direction][move.axe] = el('div.input-button.movement-button.icon-collapse.movement-'+move.direction+move.axe, {onclick:()=>{this.setDirection(move.direction, move.axe);}},
                [el('span.path1'), el('span.path2'), el('span.path3')]
            )
        ));

        let centerButton = el('div.input-button.movement-button.icon-point.movement-center', {onclick:()=>{this.eraseDirections();}},
            [el('span.path1'), el('span.path2'), el('span.path3')]
        );
        mount(buttonList, centerButton);
        mount(this.el, buttonList);
    }

    onChange:Function;
    setDirection (direction:string, axe:string) {
        if (direction == '1') {
            if (this['direction'+direction][axe] == 0) this['direction'+direction][axe] = this.directionChange;
            else this['direction'+direction][axe] = 0;
        } else {
            if (this['direction'+direction][axe] == 0) this['direction'+direction][axe] = -this.directionChange;
            else this['direction'+direction][axe] = 0;
        }
        this.checkActiveButtons();
        this.particle.setDirection1(this.direction1);
        this.particle.setDirection2(this.direction2);
        this.undo.pushState();
        if (this.onChange) this.onChange();
    }

    eraseDirections () {
        this.direction1 = {x:0, y:0, z:0};
        this.direction2 = {x:0, y:0, z:0};
        this.particle.setDirection1(this.direction1);
        this.particle.setDirection2(this.direction2);
        this.checkActiveButtons();
    }

    checkActiveButtons () {
        for (let key in this.directionButtons1) {
            if (this.direction1[key] != 0) setAttr(this.directionButtons1[key], {active:'true'});
            else setAttr(this.directionButtons1[key], {active:'false'});
        }
        for (let key in this.directionButtons2) {
            if (this.direction2[key] != 0) setAttr(this.directionButtons2[key], {active:'true'});
            else setAttr(this.directionButtons2[key], {active:'false'});
        }
    }

    resetInput (particleOptions:particleInterface) {
        if (particleOptions.direction1) this.direction1 = particleOptions.direction1;
        if (particleOptions.direction2) this.direction2 = particleOptions.direction2;
        this.checkActiveButtons();
    }
}
